import React from "react";
import ExpandableTextContainer from "@airasia/phoenix-widgets/widgets/ExpandableTextContainer";

function ExpandableTextWrapper({ textData }) {
  return (
    <ExpandableTextContainer
      accessible
      compressCtaText="Read less"
      ctaColor="secondary"
      ctaHoverColor="neutral"
      ctaHoverUnderlined
      ctaSize="small"
      ctaUnderlined
      data={textData}
      dataSliceLimit={2000}
      expandCtaText="Read more"
      theme="AIRASIA_CLASSIC"
      dataProperties={{
        titleType: "h1",
        titleColor: "neutral",
        titleMarginBottom: "normal",
        textType: "sub",
        textColor: "neutral",
        ctaColor: "primary",
        ctaSize: "small",
        ctaUnderlined: false,
        ctaHoverColor: "neutral",
        ctaHoverUnderlined: true,
        sliceLimit: 300000,
        expandCtaText: "Read more",
        compressCtaText: "Read less",
      }}
    />
  );
}

export default ExpandableTextWrapper;
